 <!-- Jumbotron -->
 <div class="page-header header-filter mt-0 mb-0" style="background-image: url('assets/img/grid.jpg')">
    <div class="container">
      <div class="row">
        <div class="col-md-8 ml-auto mr-auto">
          <div class="brand text-center">
            <h1>RegScale for Energy Sector/Utilities</h1>
            <h3 class="title text-center">Ensuring Compliance for the Nation's Critical Energy Infrastructure</h3>
              <a href="https://go.regscale.com/RegScale-Create-Account" class="btn btn-rose btn-raised btn-round ">
               Get Started
             </a>
          </div>
        </div>
      </div>
    </div>
  </div>
 
<!--    Introducting RegScale      -->
<div class="features-3" style="background-color: white;">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="text-center">
          <img class="img-fluid" style="width: 80%;" src="./assets/img/status-board.PNG">
        </div>
      </div>
      <div class="col-md-6">
        <!-- Some <br /> tags to push the text to align with the image, you can remove it if you have more text on the right side :-) -->
        <h2 class="title" style="color: #00b5e2">The Digital Core for Energy Sector Compliance</h2>
        <h4>RegScale serves as a new digital core for compliance, flexible to serve both the auditor and the audited, continuously meeting the important compliance obligations of the Energy sector for the protection of their critical infrastructure.</h4>
            <a href="https://go.regscale.com/RegScale-Create-Account" class="btn btn-rose btn-raised btn-round mt-4">
                Get Started
              </a>
              <!-- Pricing Alert - Capital -->
              <div class="container-fluid">
                <div class="alert alert-info mt-4 ml-0 mr-4">
                    
                    <div class="alert-icon">
                        <i class="material-icons">info_outline</i>
                    </div>
                    <b>Capital Purchasing Options:</b> We understand that utilities have limited OPEX budgets so we offer an array of capital purchasing options to meet the unique needs of the Energy sector.
                    
                </div>
              </div>
      </div>
    </div>
   </div>
 
    <!--     *********     Community Edition Features     *********      -->
    <div class="features-5">
      <div class="col-md-8 ml-auto mr-auto text-center">
        <h2 class="title">Common Customer Use Cases</h2>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-clipboard-check fa-2x"></i>
              </div>
              <h4 class="info-title">Audits/Assessments</h4>
              <p>Manage your audit/assessment program schedule and leverage our APIS for a real-time view into your compliance status to avoid embarrassing non-compliances that result in increased regulator involvement. </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="far fa-times-circle fa-2x"></i>
              </div>
              <h4 class="info-title">Issues Management</h4>
              <p>Track the status of non-compliance problems, conduct causal analysis, and track corrective actions to closure to pro-actively prevent recurrence of issues.
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-shield-alt fa-2x"></i>
              </div>
              <h4 class="info-title">Cyber Security</h4>
              <p>Quickly build FISMA, NERC/CIP, and other cyber security plans using our simple wizard to improve time to value, keep them evergreen leveraging our APIs to accelerate digital transformation,  and simultaneously improve quality, lower costs, and drive consistency across plans.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-bug fa-2x"></i>
              </div>
              <h4 class="info-title">Quality Assurance</h4>
              <p>Schedule and track inspections to improve product or service quality, capture defects and track corrective actions, and manage quality certification processes such as ISO 9001. </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-exclamation-triangle fa-2x"></i>
              </div>
              <h4 class="info-title">Third Party Risk</h4>
              <p>Manage your Supply Chain risk by leveraging our assessment and issues management tools to pro-actively identify non-compliances and reduce risk when flowing down requirements to subcontractors.</p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-file-signature fa-2x"></i>
              </div>
              <h4 class="info-title">Contract Management</h4>
              <p>Ensure contractual obligations are met by tracking requirement status and assessing compliance over time to maximize the value of contracts executed on behalf of the utility or company.</p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-book fa-2x"></i>
              </div>
              <h4 class="info-title">Policy Management</h4>
              <p>Draft and publish policies, track review and comment processes through disposition, build approval workflows, and capture requirements for formal tracking of compliance to improve the lifecycle management of policies and to better track implementation. </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-charging-station fa-2x"></i>
              </div>
              <h4 class="info-title">Real-Time Sensors</h4>
              <p>Integrate Internet of Things (IOT) sensors and edge computing to deliver evergreen compliance documentation for securing the grid.</p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="info">
              <div class="icon">
                <i class="fas fa-cloud fa-2x"></i>
              </div>
              <h4 class="info-title">Compliance Cloud</h4>
              <p>Visualize and dynamically report the state of compliance leveraging your very own compliance cloud, driving standardization with segregation across customers, organizations, or geographic locations.  </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cyber Use Case -->
    <div class="section section-text">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h2 class="title text-center" style="color: #00b5e2; padding-bottom: 50px;">RegScale in Action: Energy Sector Cyber Security</h2>
            <div class="card">
                <div class="card-header card-header-icon card-header-danger">
                  <div class="card-icon">
                    <h3><i class="fas fa-exclamation-circle"></i> What's the Problem?</h3>
                  </div>
                </div>
                <div class="card-body">
                    <h4 class="card-title">Energy Sector Cyber Security Regulatory Requirements</h4>
                    <p>The North American Electric Reliability Corporation (NERC) Critical Infrastructure Protection (CIP) is a set of standards that requires utilities to establish a baseline set of security measures to protect Bulk Power Systems (BPS).</p>
            
                    <p>As such, Energy sector utilities must demonstrate sustained cyber security performance, effective risk management, and results-based outcomes to ensure compliance with these standards for regulators.  The NERC CIP plan consists of 9 standards with 45 discrete requirements that ensure the protection of our energy systems.</p>
                </div>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
              <div class="card">
                  <div class="card-header card-header-icon card-header-danger">
                    <div class="card-icon">
                      <h3><i class="fas fa-chart-line"></i> How Big is the Problem?</h3>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="card card-nav-tabs">
                                <div class="card-header card-header-danger text-center">
                                  Audits and Monitoring
                                </div>
                                <div class="card-body text-center">
                                  <p class="card-text">The NERC CIP regulations require that each Regional Entity be audited at least once every 5 years.</p>
                                </div>
                              </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card card-nav-tabs">
                                <div class="card-header card-header-danger text-center">
                                  Enforcement
                                </div>
                                <div class="card-body text-center">
                                  <p class="card-text">In 2019, there were > 20 enforcement actions related to NERC CIP non-compliances resulting in fines ranging from $100k - $10M.</p>
                                </div>
                              </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card card-nav-tabs">
                                <div class="card-header card-header-danger text-center">
                                  Costs
                                </div>
                                <div class="card-body text-center">
                                  <p class="card-text">It is estimated that nearly 50% of the costs of implementing NERC CIP are related to "paperwork" and do not directly or materially contribute to cyber security improvements.</p>
                                </div>
                              </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
              <div class="card">
                  <div class="card-header card-header-icon card-header-success">
                    <div class="card-icon">
                      <h3><i class="far fa-check-circle"></i> How Do We Help?</h3>
                    </div>
                  </div>
                  <div class="card-body">
                      <div class="row">
                          <div class="col-md-4">
                            <div class="info info-horizontal">
                                <div class="icon icon-success">
                                    <i class="fas fa-check-circle"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Simple and Intuitive</h4>
                                    <p>Use an intuitive wizard (Next->Next->Finish) to rapidly build security plans</p>
                                </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="info info-horizontal">
                                <div class="icon icon-success">
                                    <i class="far fa-calendar"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Schedule and Automate</h4>
                                    <p>Plan your assessment schedule and manage both manual and automated compliance checks against your controls leveraging our APIs</p>
                                </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="info info-horizontal">
                                <div class="icon icon-success">
                                    <i class="fas fa-clipboard-list"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Track</h4>
                                    <p>Document and Assign Plan of Action and Milestones (POAMs) and track corrective actions</p>
                                </div>
                            </div>
                          </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="info info-horizontal">
                              <div class="icon icon-success">
                                <i class="fas fa-user-secret"></i>
                              </div>
                              <div class="description">
                                  <h4 class="info-title">Secure</h4>
                                  <p>Collect and store your evidence with AES-256 encryption coupled with MD5 hashes</p>
                              </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="info info-horizontal">
                              <div class="icon icon-success">
                                <i class="fas fa-tv"></i>
                              </div>
                              <div class="description">
                                  <h4 class="info-title">Compliance Workbench</h4>
                                  <p>Monitor and manage all of your assigned compliance activities in a single pane of glass</p>
                              </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="info info-horizontal">
                              <div class="icon icon-success">
                                <i class="fas fa-chart-bar"></i>
                              </div>
                              <div class="description">
                                  <h4 class="info-title">Reporting and Visualization</h4>
                                  <p>Real-time visualizations and reporting on the state of compliance across all systems in your own compliance cloud</p>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto">
              <div class="card">
                  <div class="card-header card-header-icon card-header-primary">
                    <div class="card-icon">
                      <h3><i class="far fa-handshake"></i> What Can RegScale Do For You?</h3>
                    </div>
                  </div>
                  <div class="card-body">
                      <p>RegScale is purpose-built to be deployed anywhere, whether on premises, in your own cloud instance, or consumed as a fully Managed Service.   As a vendor-neutral compliance cloud, you can manage controls across multiple frameworks and dynamically output compliance information in a format or visualization that works for you and your customer.  Management can monitor key performance indicators regarding the state of compliance across the entire enterprise, updated in real-time using automated assessments, bringing DevOps to Compliance.</p>
              
                      <p>Compliance as a platform, with a wide array of tightly integrated modules that work better together, and available as a FREE Community Edition.  Free yourself from bureaucracy today leveraging our intuitive solution to simplify compliance.</p>
                  
                      <div class="text-center">
                        <a href="https://go.regscale.com/RegScale-Create-Account" class="btn btn-rose btn-raised btn-round mt-4">
                          Get Started
                        </a>
                      </div>
                    </div>
              </div>
            </div>
          </div>
    </div>
 
    <!-- Contact Us -->
    <app-contact-us></app-contact-us>
 

